module.exports = __webpack_public_path__ + "static/media/guidedConsult.9fd7d8d5.svg";